import React, { useState } from "react";
import { Link } from "react-router-dom";
import ResponsiveImage from './ResponsiveImage';
export default function BeforeAfterSlider({before,after,alt="Photo editing example",demo=false,interactive=true,linkTo,sizes='(max-width: 768px) calc(100vw - 48px), 1100px'}) {
 const [position,setPosition]=useState(50);
 return <div className={`rg-compare${linkTo ? " rg-compare-linked" : ""}`} style={{"--split":`${position}%`}}>
  <ResponsiveImage className="rg-after" src={after} sizes={sizes} alt={`${alt} after editing`} loading="lazy" />
  <div className="rg-before-wrap"><ResponsiveImage src={before} sizes={sizes} alt={`${alt} before editing`} loading="lazy" /></div>
  <div className="rg-split-line">{interactive && <span aria-hidden="true">↔</span>}</div>
  <span className="rg-label rg-label-left">Before</span><span className="rg-label rg-label-right">After</span>
  {demo && <span className="rg-demo">Preview placeholder</span>}
  {linkTo && <Link className="rg-compare-link" to={linkTo} aria-label={`View before and after for ${alt}`} />}
  {interactive && <input type="range" min="0" max="100" value={position} aria-label={`Compare before and after: ${alt}`} aria-valuetext={`${position}% before, ${100-position}% after`} onChange={e=>setPosition(Number(e.target.value))} />}
 </div>
}
